export const SET_USER_AUTH_TOKENS = 'SET_USER_AUTH_TOKENS'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_AUTENTICATED = 'SET_USER_AUTENTICATED'
export const SET_USER_TYPE = 'SET_USER_TYPE'
export const PERFORM_LOGIN = 'PERFORM_LOGIN'
export const PERFORM_LOGOUT = 'PERFORM_LOGOUT'
export const CHECK_LOGIN = 'CHECK_LOGIN'
export const RESET_SCHEDULE = 'RESET_SCHEDULE'
export const SET_MY_AVATAR = 'SET_MY_AVATAR'
export const SET_QR_CODE_DATA = 'SET_QR_CODE_DATA'
